export const cognitoConfig = {
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
};

// export const GOOGLE_API_KEY = "AIzaSyCgoYIPhyle5bI2Ono1l5ldmXLYwMuRmf8";

export const GOOGLE_API_KEY = "AIzaSyCWWdJMdv_SczPSNMkeNlWgK-gG5nue4Mo";
